export const CURRENT_TAB="CURRENT_TAB";
export const CARD_PIN="CARD_PIN";
export const CARD_NAVIGATION="CARD_NAVIGATION";
export const ITEM_CARD_NUMBER="ITEM_CARD_NUMBER";
export const ITEM_CARD_EXPIRYDATE="ITEM_CARD_EXPIRYDATE";
export const ITEM_CARD_CVV="ITEM_CARD_CVV";
export const ITEM_CARD_HOOLDERS_NAME="ITEM_CARD_HOOLDERS_NAME";

